import { Form, Input, Row, Col, Switch } from 'antd';
import { useEffect, useRef } from 'react';
import BaseWebEditUniversal, { BaseWebEditUniversalProps } from '../system/BaseWebEditUniversal';

const FilesServiceEdit = (props: BaseWebEditUniversalProps) => {
    const { editMode } = props;
    const ref = useRef<any>(undefined);

    useEffect(() => {
    }, []);

    let extendProps: BaseWebEditUniversalProps = {
        ...props,
        formOptions: {
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={10}>
                        <Form.Item
                            label="id"
                            name="id"
                            tooltip='手动添加'
                            rules={[{ required: true, message: 'id!' }]}>
                            <Input disabled={editMode === 'NEW' ? false : true} />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="服务名称"
                            name="serviceName"
                            rules={[{ required: true, message: '服务名称!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (
        <BaseWebEditUniversal ref={ref} {...extendProps} />
    )
}

export default FilesServiceEdit;